import React, { useEffect, useState } from 'react'
import * as Styled from './MegaForm.styles'
import Spinner from './Spinner'

const LoadingStep = ({
  children = null,
  loadingStepValues = {
    title: null,
    description: null,
  },
  loadingDelayPerItem = 1000,
}) => {
  const [isLoading, setIsLoading] = useState(true)

  // Creates an array of the loadStepValues that we can map over below
  const values = Object.values(loadingStepValues)
  const totalLoadTime = (values.length + 1) * loadingDelayPerItem

  useEffect(() => {
    // Sets a timeout to go to the final step of the form after all of the animations have finished.
    // totalLoadTime is the number of items we're going to animate, which is the loadingDelayPerItem of each item,
    // plus 1 extra to give the user time to read the final bullet. This creates a false sense that
    // we're processing something - the marketing team loves this
    const timeout = setTimeout(() => {
      setIsLoading(false)
    }, totalLoadTime)

    // runs on unmount so a state change doesn't occur after the component is unmounted
    // Cleanup function to clear the timeout
    return () => clearTimeout(timeout)
  }, [totalLoadTime])

  return (
    <div>
      {isLoading && (
        <>
          <Spinner className="loading-step" />
          <Styled.LoadingHeading className="heading" variant="h4">
            Processing Request
          </Styled.LoadingHeading>
          {values.map(({ title, description }, i) => (
            <Styled.Bullet
              className="bullet"
              key={title}
              animationDelay={loadingDelayPerItem * (i + 1)}
            >
              <strong>✓ {title}: </strong>
              <span>{description}</span>
            </Styled.Bullet>
          ))}
        </>
      )}
      {!isLoading && children}
    </div>
  )
}

export default LoadingStep
